import useCurrencies from './hooks/useCurrencies'
import { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'

export default function CurrencySelector() {
  const {
    changeCurrency,
    currencies,
    currency,
    mainCurrencies,
  } = useCurrencies()
  if(!currency) {
    return null
  }
  return (
    <Fragment>
      <span className='displayed-currency' id='selected-currency'>
        {currency}
        <i className='font-icons bottom-arrow-icon' />
      </span>
      <div className='currency-list mega-menu'>
        <ul className='main-currency'>
          {Object.keys(mainCurrencies).map((currencyKey) => (
            <li
              className={cx('currency-item', {
                selected: currency === currencyKey,
              })}
              data-currency-title='{{ currency }}'
              data-navigation-elements='data-navigation-elements'
              data-region-identifier='menu-travelmain-topbar'
              onClick={() => changeCurrency(currencyKey)}
              key={currencyKey}
            >
              <span className='bold'>{currencyKey}&nbsp;</span>
              <span>
                <FormattedMessage {...mainCurrencies[currencyKey]} />
              </span>
            </li>
          ))}
        </ul>
        <ul className='another-list'>
          {Object.keys(currencies).map((currencyKey, index) => (
            <li
              key={`${currencyKey}_${index}`}
              className={cx('currency-item', {
                selected: currency === currencyKey,
              })}
              data-navigation-elements='data-navigation-elements'
              data-region-identifier='menu-travelmain-topbar'
              data-currency-title='{{ currency }}'
              onClick={() => changeCurrency(currencyKey)}
            >
              <span className='bold'>{currencyKey}&nbsp;</span>
              <span>
                <FormattedMessage {...currencies[currencyKey]} />
              </span>
            </li>
          ))}
        </ul>
      </div>
    </Fragment>
  )
}
